var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 289 67.8",
    style: {
      enableBackground: "new 0 0 289 67.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#00242E;}\n\t.st2{fill:#A97900;}\n\t.st3{opacity:0.75;fill:#00242E;enable-background:new    ;}\n\t.st4{fill:none;stroke:#00242E;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{opacity:0.5;fill:#00242E;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    transform: "translate(-43.091 -26)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.4,67.2L101.4,67.2c0-4,3.1-6.3,8.6-6.6l5.3-0.3v-1.8c0-1.9-1.3-3-3.7-3c-2.1,0-3.4,0.7-3.9,2l0,0.1h-5.4 l0-0.2c0.5-3.9,4.1-6.4,9.6-6.4c5.9,0,9.1,2.8,9.1,7.5v15.1h-5.8v-2.9h-0.4c-1.1,2-3.4,3.3-6.3,3.3 C104.3,73.8,101.4,71.2,101.4,67.2z M110.5,69.5c2.7,0,4.7-1.8,4.7-4.1v-1.6l-4.4,0.3c-2.5,0.2-3.7,1.1-3.7,2.7v0 C107.1,68.5,108.5,69.5,110.5,69.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.2,51.4h6.3l4.6,16.6h0.4l4.5-16.6h6.1l-7.6,22h-6.6L124.2,51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.8,65.7V51.4h5.9v12.9c0,3.1,1.2,4.7,3.9,4.7c2.9,0,4.4-1.9,4.4-4.9V51.4h5.9v22h-5.9v-3.4h-0.4 c-1,2.4-3.2,3.9-6.4,3.9C152.4,73.9,149.8,70.9,149.8,65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176,43h5.9v17.1h0.4l7.4-8.7h6.6l-8.5,9.4l9,12.7h-6.9l-6.4-9.1l-1.6,1.7v7.4H176L176,43L176,43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.4,67.2L198.4,67.2c0-4,3.1-6.3,8.5-6.6l5.3-0.3v-1.8c0-1.9-1.3-3-3.7-3c-2.1,0-3.4,0.7-3.9,2l0,0.1h-5.4 l0-0.2c0.5-3.9,4.1-6.4,9.6-6.4c5.9,0,9.1,2.8,9.1,7.5v15.1h-5.8v-2.9H212c-1.1,2-3.4,3.3-6.3,3.3 C201.4,73.8,198.4,71.2,198.4,67.2z M207.6,69.5c2.7,0,4.7-1.8,4.7-4.1v-1.6l-4.4,0.3c-2.5,0.2-3.7,1.1-3.7,2.7v0 C204.1,68.5,205.6,69.5,207.6,69.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M225.4,67.5V55.8H222v-4.4h3.4v-5.3h5.9v5.3h4.5v4.4h-4.5v10.4c0,2,0.8,2.9,2.8,2.9c0.8,0,1.2,0,1.7-0.1v4.3 c-0.7,0.1-1.8,0.3-2.9,0.3C227.6,73.5,225.4,71.8,225.4,67.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.8,51.4h5.9v22h-5.9V51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252.5,51.4h5.9v3.4h0.4c0.9-2.5,3.2-3.9,6.1-3.9c3,0,5.2,1.5,6.1,4.1h0.4c1-2.4,3.6-4.1,6.6-4.1 c4.4,0,7.1,2.8,7.1,7.4v15.1h-5.9V59.8c0-2.7-1.2-4-3.6-4c-2.4,0-3.9,1.7-3.9,4.1v13.6h-5.9V59.5c0-2.4-1.3-3.7-3.6-3.7 s-3.9,1.9-3.9,4.4v13.3h-5.9L252.5,51.4L252.5,51.4L252.5,51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289.6,62.5L289.6,62.5c0-7.1,4.1-11.5,10.9-11.5s10.9,4.3,10.9,11.5v0c0,7.2-4.1,11.5-10.9,11.5 S289.6,69.6,289.6,62.5z M305.4,62.5L305.4,62.5c0-4.3-1.8-6.9-4.9-6.9c-3.1,0-4.9,2.6-4.9,6.9v0c0,4.3,1.8,6.9,4.9,6.9 C303.6,69.3,305.4,66.8,305.4,62.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M316.3,43h5.9v30.5h-5.9V43z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    transform: "translate(40.509 30.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_1",
    className: "st2",
    d: "M31.4,54.8L31.4,54.8L21.8,46l9.7-22.3L41.2,46L31.4,54.8z M31.5,30.3L31.5,30.3l-6.6,15H38 L31.5,30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    className: "st1",
    d: "M12.3,45.3h6l13.1-30.2l13.5,30.2h5.9l-4.1-9.7l-2.4-4.9l-1.7-4l-2.1-4.9l-6-13.4h-5.6l-5.9,13.4 l-2.1,4.9l-1.9,4l-2.1,4.9L12.3,45.3z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.129205319708f395e31b762c06acc6eb.svg";
export { ForwardRef as ReactComponent };